import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarProvider, SidebarInset, SidebarTrigger } from '../ui/Sidebar';
import AppSidebar from './AppSidebar';
import { JwtProvider } from '../../context/JwtContext';
import JwtDialog from '../JwtDialog';
import JwtToast from '../JwtToast';

/**
 * Main layout component with consistent sidebar
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render in the main content area
 * @param {string} props.activeTab - The active tab in the dashboard
 * @param {Function} props.setActiveTab - Function to set the active tab
 * @returns {JSX.Element} MainLayout component
 */
const MainLayout = ({ children, activeTab: propActiveTab, setActiveTab: propSetActiveTab }) => {
  const location = useLocation();

  // Extract source tab from URL query parameters if available
  const queryParams = new URLSearchParams(location.search);
  const sourceTab = queryParams.get('source');

  // Use props if provided, otherwise use local state
  const [localActiveTab, setLocalActiveTab] = useState(
    location.state?.activeTab || sourceTab || 'webCheckIn'
  );

  // Use either the props or local state
  const activeTab = propActiveTab || localActiveTab;
  const setActiveTab = propSetActiveTab || setLocalActiveTab;

  return (
    <JwtProvider>
      <SidebarProvider defaultOpen={true}>
        <div className="flex h-screen w-full overflow-hidden">
          <AppSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
          <SidebarInset className="flex-1 flex flex-col min-h-0 min-w-0">
            {/* Header with Sidebar Trigger for mobile */}
            <div className="flex items-center gap-2 p-4 border-b bg-white md:hidden">
              <SidebarTrigger />
              <h1 className="text-lg font-semibold">Admin Dashboard</h1>
            </div>
            {children}
          </SidebarInset>
        </div>
        <JwtDialog />
        <JwtToast />
      </SidebarProvider>
    </JwtProvider>
  );
};

export default MainLayout;
